import request from '../request'

export function fetchList(params) {
    return request({
        url: '/model-analysis/pipe/list',
        params
    })
}
export function fetchDetail(data) {
    return request({
        url: `/model-analysis/pipe/query/${data.category}/${data.id}`,
        method:"post"
    })
}

export function add(data) {
    return request({
        url: `/model-analysis/pipe/add`,
        method: 'post',
        data
    })
}

export function edit(data) {
    return request({
        url: '/model-analysis/pipe/update',
        method: 'post',
        data
    })
}

export function del(data) {
    return request({
        url: '/model-analysis/pipe/delete',
        method: 'post',
        data
    })
}